import { BASEURL, checktoken, headers } from '../../utils/helper'
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from './other.slice';
import axios from 'axios';

const initialState = {
    total: 0,
    ride: {},
    pages: 0,
    current: 0,
    error: null,
    earnings: [],
    loading: false,
    total_earning: 0,
    upcoming_earning: 0,
}

export const AdminEarningReq = createAsyncThunk('AdminEarningReq', async ({ page, status, date }, { rejectWithValue, dispatch }) => {
    try {
        const response = await axios.get(`${BASEURL}/admin/earnings?page=${page}&status=${status}&date=${date}`,
            { headers: headers() })
            .then((res) => {
                return res.data;
            }).catch((err) => {
                checktoken(err)
                if (err?.response?.data?.error) {
                    dispatch(toastError(err?.response?.data?.error))
                }
                return rejectWithValue(err);
            })
        return response;
    } catch (error) {
        checktoken(error)
        return error;
    }
})

export const EarningSlice = createSlice({
    name: 'earningSlice',
    initialState: initialState,
    extraReducers: (builder) => {
        builder.addCase(AdminEarningReq.pending, (state, action) => {
            state.upcoming_earning = 0
            state.total_earning = 0
            state.loading = true
            state.earnings = []
            state.current = 0
            state.total = 0
            state.pages = 0
            return state
        })
        builder.addCase(AdminEarningReq.fulfilled, (state, action) => {
            state.total = action.payload.data?.total
            state.pages = action.payload.data?.pages
            state.current = action.payload.data?.current
            state.earnings = action.payload.data?.payments
            state.total_earning = action.payload.data?.total_earning
            state.upcoming_earning = action.payload.data?.upcoming_earning
            state.loading = false
            return state
        })
        builder.addCase(AdminEarningReq.rejected, (state, action) => {
            state.total = 0
            state.pages = 0
            state.current = 0
            state.earnings = []
            state.loading = false
            state.total_earning = 0
            state.upcoming_earning = 0
            state.error = 'Error occured'
        })
        builder.addCase('LOGOUT', () => initialState)
    }
})

export default EarningSlice.reducer